export const DeliveryTypes = {
  BRANCH: 'BRANCH',
  POST_OFFICE: 'POST_OFFICE',
};

export const DeliveryTypeI18nKeys = {
  [DeliveryTypes.BRANCH]: 'deliveryTypes.branch',
  [DeliveryTypes.POST_OFFICE]: 'deliveryTypes.postOffice',
};
